var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyPlace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    d: "M13 20.9472H4C3.46957 20.9472 2.96086 20.7254 2.58579 20.3306C2.21071 19.9358 2 19.4003 2 18.842V4.10525C2 3.5469 2.21071 3.01142 2.58579 2.61661C2.96086 2.2218 3.46957 2 4 2H20C20.5304 2 21.0391 2.2218 21.4142 2.61661C21.7893 3.01142 22 3.5469 22 4.10525V12.5262",
    stroke: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    d: "M22.0002 17.0318C22.0001 17.6651 21.7622 18.2728 21.3382 18.7223C20.3622 19.758 19.4152 20.838 18.4022 21.8359C18.2891 21.9447 18.1405 22.0035 17.9873 22.0002C17.8341 21.9968 17.688 21.9316 17.5792 21.818L14.6612 18.7233C14.2371 18.2736 13.999 17.6655 13.999 17.0318C13.999 16.398 14.2371 15.79 14.6612 15.3402C14.8729 15.1156 15.1247 14.9373 15.4022 14.8157C15.6796 14.694 15.9772 14.6314 16.2777 14.6314C16.5783 14.6314 16.8759 14.694 17.1533 14.8157C17.4307 14.9373 17.6826 15.1156 17.8942 15.3402L18.0002 15.4528L18.1062 15.3402C18.4241 15.0027 18.8302 14.7723 19.2727 14.6782C19.7153 14.5842 20.1745 14.6308 20.5919 14.8121C21.0092 14.9934 21.366 15.3012 21.6167 15.6965C21.8675 16.0917 22.001 16.5565 22.0002 17.0318Z",
    stroke: "none",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    d: "M11 4.11607L11.01 4.10449M2 6.21079H22H2ZM5 4.11607L5.01 4.10449L5 4.11607ZM8 4.11607L8.01 4.10449L8 4.11607Z",
    stroke: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPlace);
export default __webpack_public_path__ + "static/media/my-place.28cf490a4407a22c49f374925331c52b.svg";
export { ForwardRef as ReactComponent };